import {clampValue, valuesAreEqualWithinPrecision} from "../../global/globalUtils";
import {PlusMinus} from "./patternViewComponent";

export class PatternSizeSteps {

    private static readonly NUMBEROF_SIZE_STEPS = 20;
    private static readonly SNAPTOVALUE_RANGECM = 0.1;
    private readonly minSize;
    private readonly maxSize;
    private readonly standardSize;
    private patternSizeSteps = [] as number[];

    public constructor(minSize:number, maxSize:number, standardSize:number) {
        this.maxSize = maxSize;
        this.minSize = minSize;
        this.standardSize = standardSize;
        this.setSizeStepNrs();

    }
    private static getStepSize = (min, max)=>Math.abs(max - min) / PatternSizeSteps.NUMBEROF_SIZE_STEPS;

    private setSizeStepNrs() {
        const step = PatternSizeSteps.getStepSize(this.minSize, this.maxSize);
        let currentSize = this.minSize;

        const getNextStep = (current)=>{
            current = parseFloat(current) + step;
            if(PatternSizeSteps.snapsToValue(current, this.standardSize) && this.patternSizeSteps.indexOf(this.standardSize) === -1) {
                return this.standardSize;
            }
            if(PatternSizeSteps.snapsToValue(current, this.maxSize)) {
                return this.maxSize;
            }
            return current.toFixed(2);
        }

        while(currentSize < this.maxSize) {
            this.patternSizeSteps.push(currentSize);
            currentSize = getNextStep(currentSize);
        }
        this.patternSizeSteps.push(this.maxSize);
    }

    private static snapsToValue(toTest, targetvalue) {
        return valuesAreEqualWithinPrecision(toTest, targetvalue, PatternSizeSteps.SNAPTOVALUE_RANGECM);
    }

    public snapInsertTargetSizeToStandard = (targetSize)=>{
        return PatternSizeSteps.snapsToValue(targetSize, this.standardSize) ?
            this.standardSize :
            targetSize;
    }

    public getStepSize() {
        return PatternSizeSteps.getStepSize(this.minSize, this.maxSize);
    }

    public getSizeStepNumber(targetSize) {
        let delta = Infinity;
        let indexWithMinDelta = -1;
        for(let i=0; i< this.patternSizeSteps.length; i++) {
            const currentDelta = Math.abs(targetSize - this.patternSizeSteps[i]);
            if(currentDelta < delta) {
                delta = currentDelta;
                indexWithMinDelta = i;
            }
        }
        return indexWithMinDelta+1;
    }

    public getTargetWidthCMForStepNr(stepnumber:number) {
        return this.patternSizeSteps[clampValue(stepnumber, 0, this.patternSizeSteps.length-1)];
    }

    getNewSizeInDirection(currentSize, plusMinus:PlusMinus) {
        const step = this.getStepSize() * (plusMinus === "plus" ? 1 : -1);
        currentSize =parseFloat(currentSize)+step;
        return clampValue(this.snapInsertTargetSizeToStandard(currentSize), this.minSize, this.maxSize);
    }

}
